import * as React from "react";
import type { SVGProps } from "react";
const SvgUserProfile03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M16.046 7.294c0 2.702-1.717 4.676-3.834 4.676S8.378 9.996 8.378 7.294 10.095 2.4 12.212 2.4s3.834 2.19 3.834 4.894ZM4.4 15.885c.275-.502.78-.81 1.325-.81h12.55c.546 0 1.05.308 1.325.81l1.789 3.262c.596 1.087-.141 2.453-1.325 2.453H3.936c-1.184 0-1.921-1.366-1.325-2.453z"
    />
  </svg>
);
export default SvgUserProfile03;
